/**
 * Vendor
 */

require('lazysizes')

require('./polyfills.js')

require('./components/form.js')
require('./components/search.js')
require('./components/gallery.js')


/**
 * Fix for iOS to be able to open dropdown menus without directly navigating to the link
 */
window.addEventListener('touchstart', function onFirstTouch () {
  document.body.classList.add('has-touch')

  document.querySelectorAll('.has-touch .main-nav a[data-has-dropdown]').forEach(link => {
    link.addEventListener('click', () => {
      event.preventDefault()
    })
  })

  // we only need to know once that a human touched the screen, so we can stop listening now
  window.removeEventListener('touchstart', onFirstTouch, false)
}, false)


// WEBPACK FOOTER //
// ./source/js/index.js